export const SHARING_VALUE = {
  ALL_CORPORATE: 0,
};
